import { BackgroundImage, Box, Flex, Text } from '@library/uikit'
import Heading from '@library/uikit/src/components/Heading/Heading'
import getThemeValue from '@library/uikit/src/util/getThemeValue'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalTitle } from '@library/uikit/src/widgets/Modal'
import { NextLinkFromReactRouter } from 'components/NextLink'
import { useTranslation } from '@library/localization'

import { gsap } from 'gsap'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import chunk from 'lodash/chunk'
import React, { useEffect, useState } from 'react'
import styled, { useTheme } from 'styled-components'
import { nftsBaseUrl } from 'views/Gens/Market/constants'

const StyledGen = styled(BackgroundImage)`
  height: 95px;
  width: 95px;
  border-radius: 10px;
  ${({ theme }) => theme.mediaQueries.sm} {
    height: 120px;
    width: 120px;
  }
`

interface Props {
  ids: number[]
  images: { [key: number]: string }
  onDismiss?: () => void
}

const BlindBoxResultModal: React.FC<Props> = ({ ids, images, onDismiss = () => null }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { chainId } = useActiveWeb3React()
  const [gens, setGens] = useState([[]])

  const [title, setTitle] = useState(t('Congratulations get new Gen!'))

  useEffect(() => {
    if (ids.length) {
      setTitle(t('Congratulations get new Gen!'))
      setGens(chunk(ids, 3))

      setTimeout(() => {
        gsap
          .timeline({ defaults: { duration: 1 } })
          .fromTo('.blindBoxModalContainer', { scale: 0 }, { scale: 1 })
          .fromTo('.blindBoxGens', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1, stagger: 0.5 })
      })
    } else {
      setTitle(t('Unlucky!'))
    }
  }, [ids, t])

  return (
    <ModalContainer className="blindBoxModalContainer" minWidth="320px" minHeight="400px">
      <ModalHeader background={getThemeValue('colors.gradients.bubblegum')(theme)}>
        <ModalTitle>
          <Heading>{title}</Heading>
        </ModalTitle>
        <ModalCloseButton onDismiss={onDismiss} />
      </ModalHeader>
      <ModalBody width={[null, null, '500px']} pb={30}>
        {ids.length ? (
          gens.map((gen, index) => (
            <Flex
              key={index}
              style={{ gap: '20px' }}
              mt="32px"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
              {gen.map((id, index) => (
                <NextLinkFromReactRouter onClick={onDismiss} key={index} to={`${nftsBaseUrl}/luca/${id}`}>
                  <StyledGen
                    className="blindBoxGens"
                    backgroundSizeMode="contain"
                    src={images[id]}
                    height={120}
                    width={120}
                    alt={t('Gen')}
                  />
                </NextLinkFromReactRouter>
              ))}
            </Flex>
          ))
        ) : (
          <Box p="24px">
            <Text fontSize="24px" bold>
              {t("You didn't get any gen!")}{' '}
            </Text>
          </Box>
        )}
      </ModalBody>
    </ModalContainer>
  )
}

export default BlindBoxResultModal
